<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">凭证控制</h3>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-row>
                        <el-col>
                            <el-select
                                v-model="selTenantId"
                                placeholder="请选择商户"
                                @change="TenantChange"
                                size="mini"
                                class="right-20"
                                filterable
                            >
                                <el-option
                                    v-for="item in Tenants"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-plus"
                                class="pull-right"
                                @click="addInfo"
                                v-if="isMaxNum"
                                >新增</el-button
                            >
                        </el-col>
                    </el-row>
                    <el-table
                        :data="tableData"
                        size="mini"
                        style="width: 100%; margin-top: 10px"
                        border
                    >
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="bottom">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        @click="editRow(scope.row)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="bottom">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click="deleteEntity(scope.row._id)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="tenantName"
                            label="商户"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="是否启用挂账"
                            prop="isOnAccount"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isOnAccount)
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            label="挂账结算方式编码"
                            prop="paywayAccountCode"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column label="是否暂存凭证" align="center">
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isDraftVoucher)
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            label="是否启用应收模块"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isEnableReceivOrder)
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            label="是否包含套餐明细"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isNeedPkDetails)
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            label="结算方式是否只包含纯收"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isPaywayOnlyInCome)
                            }}</template>
                        </el-table-column>
                        <el-table-column label="是否启用过滤源" align="center">
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isFilterPayway)
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            label="是否启用贷方结算方式科目"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isCrebitPaywaySubject)
                            }}</template>
                        </el-table-column>

                        <el-table-column
                            label="是否启用门店菜谱"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isShopItem)
                            }}</template>
                        </el-table-column>

                        <el-table-column
                            label="是否凭证日期设为查询日期"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                isOrNo(scope.row.isVoucherDateSetQueryDay)
                            }}</template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="voucherControlUrl"
                        :GetData="initData"
                        :queryParam="queryParams"
                        :errorFunc="closeOpenloading"
                    ></pagerBar>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            v-el-drag-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="38%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                label-width="130px"
                :model="formLabel"
                ref="controlEditForm"
            >
                <el-form-item label="是否启用挂账">
                    <el-switch
                        v-model="formLabel.isOnAccount"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item
                    label="挂账结算方式编码"
                    v-show="formLabel.isOnAccount == 1"
                >
                    <el-input
                        v-model="formLabel.paywayAccountCode"
                        placeholder="请输入挂账结算方式编码"
                        style="width: 30%"
                    ></el-input>
                </el-form-item>
                <el-form-item label="是否暂存凭证">
                    <el-switch
                        v-model="formLabel.isDraftVoucher"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="是否包含应收">
                    <el-switch
                        v-model="formLabel.isEnableReceivOrder"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="是否包含套餐明细">
                    <el-switch
                        v-model="formLabel.isNeedPkDetails"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="结算方式是否只包含纯收">
                    <el-switch
                        v-model="formLabel.isPaywayOnlyInCome"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="是否启用过滤源">
                    <el-switch
                        v-model="formLabel.isFilterPayway"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="是否启用贷方结算方式科目">
                    <el-switch
                        v-model="formLabel.isCrebitPaywaySubject"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="是否启用门店菜谱">
                    <el-switch
                        v-model="formLabel.isShopItem"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="是否凭证日期设为查询日期">
                    <el-switch
                        v-model="formLabel.isVoucherDateSetQueryDay"
                        :active-value="1"
                        :inactive-value="0"
                    ></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="SaveEntity()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
export default {
    data() {
        return {
            //TODO
            Tenants: [], //商户
            isMaxNum: false, //是否超出最大数
            isOn: true,
            isOff: false,
            openloading: true,
            dialogVisible: false, // 弹窗显示
            tableData: [],
            controlInfoUlr: config.BASE_Middle_API + 'VoucherControl',
            //基础资料类别列表数据获取
            voucherControlUrl: config.BASE_Middle_API + 'VoucherControl/GetAll',
            //新增or修改
            createOrEditUrl: config.BASE_Middle_API + 'VoucherControl/Add',
            //删除
            deleteUrl: config.BASE_Middle_API + 'VoucherControl/Delete',
            //得到信息实体
            GetEntityUrl: config.BASE_Middle_API + 'VoucherControl/Edit',
            title: '新增控制',
            operation: '',
            selTenantId: '',
            formLabel: {
                isDraftVoucher: 0,
                isOnAccount: 0,
                isEnableReceivOrder: 0,
                tenantId: 0,
                paywayAccountCode: '',
                isNeedPkDetails: 0,
                isPaywayOnlyInCome: 0,
                isFilterPayway: 0,
                isCrebitPaywaySubject: 0
            },
            queryParams: { ArchiveFilter: '', tenantID: 0 }
        }
    },
    components: {
        pagerBar
    },
    mounted: function () {
        this.getTenants()
    },
    methods: {
        closeOpenloading() {
            this.openloading = false
        },
        isOrNo(val) {
            return val == '1' ? '是' : '否'
        },
        getTenants() {
            const _this = this
            AjaxHelper.get(_this.controlInfoUlr + '/GetTenants')
                .then(function (response) {
                    if (response.success) {
                        _this.Tenants = response.result
                        _this.openloading = false
                    }
                })
                .catch(function (error) {
                    _this.openloading = false
                })
        },
        TenantChange(tenantID) {
            this.openloading = true
            this.queryParams.tenantID = tenantID
        },
        //新增基础资料类别
        addInfo() {
            this.clearformLabel()
            this.dialogVisible = true
            this.operation = 'add'
            this.title = '新增控制'
        },
        clearformLabel() {
            const _this = this
            _this.formLabel.isDraftVoucher = 0
            _this.formLabel.isOnAccount = 0
            _this.formLabel.isEnableReceivOrder = 0
            _this.formLabel.tenantId = 0
            _this.formLabel.paywayAccountCode = ''
            _this.formLabel.isNeedPkDetails = 0
            _this.formLabel.isPaywayOnlyInCome = 0
            _this.formLabel.isFilterPayway = 0
            _this.formLabel.isCrebitPaywaySubject = 0
        },
        initData(d) {
            const _this = this
            _this.tableData = d
            if (d.length >= 1 || _this.selTenantId == 0) {
                this.isMaxNum = false
            } else {
                this.isMaxNum = true
            }
            _this.openloading = false
        },
        //编辑
        editRow(row) {
            const _this = this
            _this.title = '编辑凭证控制'
            _this.operation = 'edit'
            this.dialogVisible = true
            _this.formLabel = Object.assign({}, row)
        },
        deleteEntity(deleteId) {
            const _this = this
            this.$confirm('此操作将删除该控制信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            })
                .then(() => {
                    AjaxHelper.delete(_this.deleteUrl, {
                        tempId: deleteId,
                        tenantID: _this.selTenantId
                    })
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                })
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {
                            // _this.$message({
                            //   type: "danger",
                            //   message: error
                            // });
                        })
                })
                .catch((e) => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        //保存基础资料档案
        SaveEntity() {
            const _this = this
            this.$refs['controlEditForm'].validate((valid) => {
                let postUrl = ''
                if (_this.operation == 'add') {
                    postUrl = '/Add'
                } else {
                    postUrl = '/Edit'
                }
                _this.formLabel.tempId = _this.formLabel._id
                _this.formLabel.tenantId = _this.selTenantId
                if (valid) {
                    AjaxHelper.post(
                        _this.controlInfoUlr + postUrl,
                        _this.formLabel
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '操作成功'
                                })
                                _this.pagesize = 1
                                _this.clearformLabel()
                                _this.Refresh()
                                _this.dialogVisible = !_this.dialogVisible
                            } else {
                                _this.$message({
                                    type: 'error',
                                    message: response.Messages[0]
                                })
                            }
                        })
                        .catch(function (error) {
                            _this.$message({
                                type: 'error',
                                message: error
                            })
                        })
                }
            })
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh()
        },
        handleClose(done) {
            done()
        }
    }
}
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
.el-card {
    height: calc(100vh - 217px) !important;
}
</style>
